import { IObservableArray } from "mobx";
import { NameSortable } from "@/interfaces/NameSortable";

export const toShallowJs = <T extends string | NameSortable>(collections: IObservableArray<T>): T[] => {
  return collections.toJS();
};

export const toShallowJsAsc = (collections: IObservableArray<string>) => {
  return toShallowJs(collections).sort();
};

export const toShallowSortableJsAsc = <T extends NameSortable>(collections: IObservableArray<T>): T[] => {
  return toShallowJs(collections).sort((a, b) => a.name.localeCompare(b.name));
};
